export default {
    api: {
        url: 'https://devhrmapi.mobcoder.com/hrm/api/v1/',
        mode: 'cors'
    }
}
